import isEmpty from 'lodash/isEmpty';

function useRecognition() {
  async function recognize(url, headers, body, blob, documentName, country, progress) {
    if (isEmpty(url)) return;

    const form = new FormData();
    form.append('document', blob);
    form.append('document_name', documentName);
    form.append('country', country);

    for (const key in body) {
      form.append(key, body[key]);
    }

    return new Promise(async function(resolve) {
      const xhr = new XMLHttpRequest();
      xhr.timeout = 170000;

      xhr.open('POST', url, true);

      for (const key in headers) {
        xhr.setRequestHeader(key, headers[key]);
      }

      xhr.addEventListener('load', event => {
        progress(100);

        if (xhr.status !== 200) return resolve({ error: true });

        const result = JSON.parse(xhr.response);

        if (result.recognition_result && result.recognition_result.recognition_status) {
          resolve({ result: result.recognition_result.recognition_status, error: false });
        } else {
          resolve({ error: true });
        }
      });

      xhr.addEventListener('error', event => {
        progress(100);
        resolve({ error: true });
      });

      xhr.ontimeout = (e) => {
        progress(100);
        resolve({ error: true });
      };

      if (xhr.upload) {
        xhr.upload.onprogress = function(event) {
          const percentage = Math.floor(event.loaded * 50 / event.total);
          progress(percentage);
        };
      }

      xhr.send(form);
    });
  }

  return [recognize];
}

export default useRecognition;
